import { render, staticRenderFns } from "./LeaveTypesView.vue?vue&type=template&id=6f211472"
import script from "./LeaveTypesView.vue?vue&type=script&lang=js"
export * from "./LeaveTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports